<div class="pre-post-op-control-main" [ngStyle]="{'height' : isExpanded ? '100%' : '42px'}" data-cy="tdo-pre-post-op-control">
  <div class="pre-post-op-control-item" cdkDropList
    appDragFileToBrowser (files)="onFilesDropped($event, 'preop')"
    (cdkDropListDropped)="onPreOpDropped($event)"
    [ngClass]="{'pre-post-op-control-selected-item': isSelectedItem('preop')}"
    (contextmenu)="onRightMouseClick($event,'Pre Op', 'preop'); false"
    (mouseover)="onItemMouseOver('preop')"
    (mouseout)="onItemMouseOut('preop')"
    style="margin-right: 1px;" data-cy="tdo-pre-post-op-preop-item">
    @if ((isMouseOver || !preopImageSrc) && isExpanded) {
      <div style="position: absolute; left: 4px; color: var(--tdo-primary-accent); font-weight: 500; " data-cy="tdo-pre-post-op-preop-label">Pre Op</div>
    }
    @if (preopDocs.length > 1 && preopIndex > 0) {
      <div (click)="preopIndex = preopIndex - 1; false" style="position: absolute; bottom: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-preop-prev">
        <lucide-icon name="chevron-left" [size]="20"></lucide-icon>
      </div>
    }
    @if (preopDocs.length > 1 && preopIndex < preopDocs.length - 1) {
      <div (click)="preopIndex = preopIndex + 1; false" style="position: absolute; bottom: 0; right: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-preop-next">
        <lucide-icon name="chevron-right" [size]="20"></lucide-icon>
      </div>
    }
    <div style="width: 100%; height: 100%;" (dblclick)="onDoubleClick('preop')" data-cy="tdo-pre-post-op-preop-container">
      @if (preopDocs.length == 0) {
        <div style="text-align: center; height: 100%; width: 100%;" data-cy="tdo-pre-post-op-preop-empty">
          <img src="assets/Images/icons8-mouse-right-click.svg" style="position: relative; top: 50%; transform: translateY(-50%); margin-left: auto; margin-right: auto;" data-cy="tdo-pre-post-op-preop-empty-icon" />
        </div>
      }
      @if (preopDocs.length > 0) {
        <div style="width: 100%; height: 100%;align-content: center; text-align: center;" data-cy="tdo-pre-post-op-preop-content">
          <img [src]="getImageSource('preop') | secureImage | async"  style="max-width: 100%; max-height: 100%;  border-radius: 6px;" data-cy="tdo-pre-post-op-preop-image" />
        </div>
      }
    </div>
  </div>


  <div class="pre-post-op-control-item" cdkDropList
    appDragFileToBrowser (files)="onFilesDropped($event, 'postop')"
    (cdkDropListDropped)="onPostOpDropped($event)"
    [ngClass]="{'pre-post-op-control-selected-item': isSelectedItem('postop')}"
    (contextmenu)="onRightMouseClick($event,'Post Op', 'postop'); false"
    (mouseover)="onItemMouseOver('postop')"
    (mouseout)="onItemMouseOut('postop')"
    style="margin-right: 1px;" data-cy="tdo-pre-post-op-postop-item">
    @if ((isMouseOver || !postopImageSrc) && isExpanded) {
      <div style="position: absolute; left: 4px; color: var(--tdo-primary-accent); font-weight: 500; " data-cy="tdo-pre-post-op-postop-label">Post Op</div>
    }
    @if (postopDocs.length > 1 && postopIndex > 0) {
      <div (click)="postopIndex = postopIndex - 1; false" style="position: absolute; bottom: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-postop-prev">
        <lucide-icon name="chevron-left" [size]="20"></lucide-icon>
      </div>
    }
    @if (postopDocs.length > 1 && postopIndex < postopDocs.length - 1) {
      <div (click)="postopIndex = postopIndex + 1; false" style="position: absolute; bottom: 0; right: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-postop-next">
        <lucide-icon name="chevron-right" [size]="20"></lucide-icon>
      </div>
    }
    <div style="width: 100%; height: 100%;" (dblclick)="onDoubleClick('postop')" data-cy="tdo-pre-post-op-postop-container">
      @if (postopDocs.length == 0) {
        <div style="text-align: center; height: 100%; width: 100%;" data-cy="tdo-pre-post-op-postop-empty">
          <img src="assets/Images/icons8-mouse-right-click.svg" style="position: relative; top: 50%; transform: translateY(-50%); margin-left: auto; margin-right: auto;" data-cy="tdo-pre-post-op-postop-empty-icon" />
        </div>
      }
      @if (postopDocs.length > 0) {
        <div style="width: 100%; height: 100%;align-content: center; text-align: center;" data-cy="tdo-pre-post-op-postop-content">
          <img [src]="getImageSource('postop') | secureImage | async" style="max-width: 100%; max-height: 100%; border-radius: 6px; text-align: center;" data-cy="tdo-pre-post-op-postop-image" />
        </div>
      }
    </div>
  </div>
</div>

<ng-template #pasteMenu let-data>
  <section class="image-context-menu" data-cy="tdo-pre-post-op-context-menu">
    @if (isPasteableData()) {
      <div (click)="onPaste(data)" class="item" data-cy="tdo-pre-post-op-context-paste">Paste</div>
    }
    <div (click)="openAll(data)" class="item" data-cy="tdo-pre-post-op-context-open-all">Open all {{lastItemName}}</div>
    <div (click)="onAcquire(data)" class="item" data-cy="tdo-pre-post-op-context-acquire">Acquire</div>
    <div (click)="onRemoveAssociation(data)" class="item" data-cy="tdo-pre-post-op-context-remove">Remove</div>
    @if (isDesktopAcquire) {
      <div (click)="onAcquire(data)" class="item" data-cy="tdo-pre-post-op-context-desktop-acquire">Acquire</div>
    }
  </section>
</ng-template>
